import { useLocation, useNavigate } from 'react-router-dom';

interface HeaderProps {
  plantCount?: number;
}

export function Header({ plantCount: _plantCount = 0 }: HeaderProps) {
  const location = useLocation();
  const navigate = useNavigate();

  const isHomePage = location.pathname === '/home';
  const isSettingsPage = location.pathname === '/settings';
  const isActivityPage = location.pathname === '/activity';

  // Pages that use the centered editorial header
  if (isHomePage || isSettingsPage || isActivityPage) {
    return (
      <header className="sticky top-0 z-30 border-b border-gray-200 bg-background/95 backdrop-blur-sm px-6 py-4 flex items-center justify-between">
        <div className="w-8" />
        <h1 className="font-serif text-sm uppercase tracking-[0.2em] font-medium text-center flex-1 text-editorial-black">
          Chloropal
        </h1>
        {isHomePage ? (
          <button
            onClick={() => navigate('/add')}
            className="w-8 flex justify-end text-editorial-black hover:text-gray-600 transition-colors"
            aria-label="Add new plant"
          >
            <span className="material-symbols-outlined" aria-hidden="true">add</span>
          </button>
        ) : (
          <div className="w-8" />
        )}
      </header>
    );
  }

  // Sub-pages: back button + centered title
  const pageTitle = getPageTitle(location.pathname);

  return (
    <header className="sticky top-0 z-30 border-b border-gray-200 bg-background/95 backdrop-blur-sm px-4 py-3 flex items-center justify-between">
      <button
        onClick={() => navigate(-1)}
        className="flex h-10 w-10 items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
        aria-label="Go back"
      >
        <span className="material-symbols-outlined text-editorial-black" aria-hidden="true">arrow_back</span>
      </button>
      {pageTitle && (
        <h1 className="font-display text-xl font-bold tracking-tight text-editorial-black italic">
          {pageTitle}
        </h1>
      )}
      <div className="w-10" />
    </header>
  );
}

function getPageTitle(pathname: string): string | null {
  if (pathname === '/add') return 'Add Plant';
  if (pathname.endsWith('/edit')) return 'Edit Plant';
  if (pathname.endsWith('/diagnose')) return null; // DiagnosePlant has its own header
  if (pathname.includes('/diagnosis/')) return 'Health Report';
  if (pathname === '/shopping') return 'Shopping List';
  // PlantDetail has its own hero header
  return null;
}
